import React from "react";
import * as ANTD from "antd";
import "./PrintTicket.scss";
import { Modal } from "antd";
import {
  MessageOutlined,
  MailOutlined,
  DownloadOutlined,
  DownOutlined,
} from "@ant-design/icons";

const PrintTicket = () => {
  const { Content } = ANTD.Layout;
  const [modalVisible, setModalVisible] = React.useState(false);

  const showModal = () => {
    setModalVisible({
      visible: true,
    });
  };

  const Print = (
    <ANTD.Menu>
      <ANTD.Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="#">
          Print Confirmation
        </a>
      </ANTD.Menu.Item>
      {/* <ANTD.Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="#">
          Print Confirmation Without Price
        </a>
      </ANTD.Menu.Item> */}
    </ANTD.Menu>
  );

  const Email = (
    <ANTD.Menu>
      <ANTD.Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="#">
          Email With Price
        </a>
      </ANTD.Menu.Item>
      {/* <ANTD.Menu.Item>
        <a target="_blank" rel="noopener noreferrer" href="#">
          Email Without Price
        </a>
      </ANTD.Menu.Item> */}
    </ANTD.Menu>
  );

  return (
    <div>
      <div className="promo providerapi">
        <ANTD.Layout>
          <div className="manage-markup-section">
            <Content className="admin-container">
              <ANTD.Row>
                <ANTD.Col span={24}>
                  <div className="card-bt-gap">
                    <div className="card-add-heading">
                      <h3>Print Ticket</h3>
                    </div>
                  </div>
                </ANTD.Col>
              </ANTD.Row>

              <ANTD.Row>
                <ANTD.Col span={24}>
                  <ANTD.Card>
                    <div className="">
                      <h5>Enter Ticket Details</h5>
                    </div>
                    <ANTD.Form name="basic" initialValues={{ remember: true }}>
                      <ANTD.Row gutter={24}>
                        <ANTD.Col className="gutter-class" md={8} xs={24}>
                          <ANTD.Form.Item
                            label="Reference ID"
                            name="Reference ID"
                            rules={[{ message: "Please input your username!" }]}
                          >
                            <ANTD.Input 
 autocomplete="newpassword"  />
                          </ANTD.Form.Item>
                        </ANTD.Col>

                        <ANTD.Col className="gutter-class" md={8} xs={24}>
                          <ANTD.Form.Item
                            label="Mobile"
                            name="Mobile"
                            rules={[{ message: "Please input your username!" }]}
                          >
                            <ANTD.Input 
 autocomplete="newpassword"  />
                          </ANTD.Form.Item>
                        </ANTD.Col>

                        <ANTD.Col className="gutter-class" md={8} xs={24}>
                          <ANTD.Form.Item>
                            <ANTD.Button
                              type="primary"
                              onClick={showModal}
                              className="retrive-btn"
                            >
                              Retrieve
                            </ANTD.Button>
                          </ANTD.Form.Item>
                        </ANTD.Col>
                      </ANTD.Row>
                    </ANTD.Form>
                  </ANTD.Card>
                </ANTD.Col>
              </ANTD.Row>
            </Content>
          </div>
        </ANTD.Layout>

        <Modal
          title={[
            <div>
              <h6 style={{ marginBottom: "0px" }}>
                <strong>Print Ticket</strong>
              </h6>
            </div>,
          ]}
          className="promo-modal-header cancel-modal"
          visible={modalVisible}
          onOk={(e) => setModalVisible(false)}
          onCancel={(e) => setModalVisible(false)}
          footer={[
            <div>
              {/*  <ANTD.Button key="add" type="primary"  >Print Ticket</ANTD.Button> */}
            </div>,
          ]}
        >
          <ANTD.Row className="print-ticket-btn">
            <ANTD.Dropdown overlay={Print} placement="bottomCenter">
              <ANTD.Button className="all-print-btn" type="primary">
                Print
                <DownOutlined className="printmail" />
              </ANTD.Button>
            </ANTD.Dropdown>

            {/* <ANTD.Button className="all-print-btn" type="primary"><PrinterOutlined />Print</ANTD.Button> */}
            <ANTD.Button className="all-print-btn" type="primary">
              <MessageOutlined />
              SMS
            </ANTD.Button>

            <ANTD.Dropdown overlay={Email} placement="bottomCenter">
              <ANTD.Button className="all-print-btn" type="primary">
                <MailOutlined />
                Email
              </ANTD.Button>
            </ANTD.Dropdown>
            {/* <ANTD.Button className="all-print-btn" type="primary"><MailOutlined />Email</ANTD.Button> */}
            <ANTD.Button className="all-print-btn" type="primary">
              <DownloadOutlined />
              Download
            </ANTD.Button>

            <ANTD.Col md={24} xs={24}></ANTD.Col>
          </ANTD.Row>
        </Modal>
      </div>
    </div>
  );
};
export default PrintTicket;
